<template>
    <div>
        <v-runtime-template v-if="portalHtml" :template="`<div> ${portalHtml} </div> `"></v-runtime-template>
    </div>
</template>


<script>
    import LabBase from './LabStorageBase';
    import Customization from "./Customization";

    export default {
        name: 'lab-portal',
        mixins: [LabBase],
        props: {},
        data() {
            return {
                portalHtml: null //"hello, this is tenant1's home. <br><class-list/>"
            }
        },

        watch: {
        },
        beforeDestroy(){
            console.log('LabPortal Before')
            this.$EventBus.$emit('showNewButton', false)
        },
        created: async function () {
            var me = this;
            me.$EventBus.$emit('showNewButton', true)
            Vue.component('customization', Customization)

            if (!window.location.href.includes('localhost') && (window.MODE != "onprem")){
                me.portalHtml = await me.getString("minio://index.html");
            }

            // console.log('portalHtml!!!!!!!!')
            if ( !me.portalHtml ) {
                me.portalHtml = "<project-list></project-list>"
                // me.portalHtml = "<customization title=\"GK Cloud Lab\" home=\"http://www.gkcloudlab.io\"></customization> " +
                //     "<project-list> </project-list>"
            }


            // me.portalHtml.__ob__.dep.notify();
        },
        methods: {

        }
    }
</script>


